import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { api, apiTags } from '~shared/api/origin';
import { eventsInbox, EventType } from '~shared/services/eventsInbox';

import type { AppDispatch } from '../../store';

export const useFreeGiftWatcher = (botId: string, freeGiftId: string) => {
	const dispatch = useDispatch<AppDispatch>();

	useEffect(
		() =>
			eventsInbox.onTypeMsg(EventType.ChatMessageReceived, (payload) => {
				if (!botId || !freeGiftId) return;

				const { meta, recipient } = payload;
				if (meta?.gift === freeGiftId && recipient === botId) {
					dispatch(api.util.invalidateTags([apiTags.gifts]));
				}
			}),
		[botId, dispatch, freeGiftId]
	);
};
